export default __webpack_public_path__ + "static/download-icon-ef8b69cba8254712fde5155ba8da256b.svg";